<div class="auth-wrapper auth-v1 px-2">
  <div class="auth-inner py-2">
    <!-- Login v1 -->
    <div
      [@zoomInAnimation]="zoomState"
      class="card mb-0">
      <div class="card-body">
        <a
          class="brand-logo"
          href="/">
          <img
            [src]="logoService.logoPath"
            alt="brand-logo"
            height="50" />
        </a>

        <h4
          [translate]="'AUTH.WELCOME'"
          class="card-title mb-1"></h4>
        <p
          [translate]="'AUTH.INTRO'"
          class="card-text mb-2"></p>

        <form
          (ngSubmit)="onSubmit()"
          [formGroup]="loginForm"
          class="auth-login-form mt-2">
          <div class="mb-3">
            <label
              [translate]="'AUTH.EMAIL'"
              class="form-label"
              for="login-email"></label>
            <div
              [ngClass]="{ 'is-invalid': submitted && f['email'].errors }"
              class="input-group input-group-merge">
              <div class="input-group-prepend">
                <span class="input-group-text"><span [data-feather]="'user'"></span></span>
              </div>
              <input
                [ngClass]="{ 'is-invalid': submitted && f['email'].errors }"
                aria-describedby="login-email"
                autofocus
                class="form-control"
                formControlName="email"
                id="login-email"
                placeholder="max@mustermann.at"
                tabindex="1"
                type="email" />
            </div>
            @if (submitted && f["email"].errors) {
              <div class="invalid-feedback">
                @if (f["email"].errors["required"]) {
                  <div [translate]="'AUTH.ERRORS.EMAIL_REQUIRED'"></div>
                }
                @if (f["email"].errors["email"]) {
                  <div [translate]="'AUTH.ERRORS.EMAIL'"></div>
                }
              </div>
            }
          </div>

          <div class="mb-3">
            <div class="d-flex justify-content-between">
              <label
                [translate]="'AUTH.PASSWORD.PASSWORD'"
                for="login-password"></label>
              <a routerLink="/forgot-password">
                <small [translate]="'AUTH.PASSWORD.FORGOT'"></small>
              </a>
            </div>
            <div
              [ngClass]="{
                'is-invalid error': submitted && f['password'].errors,
              }"
              class="input-group input-group-merge form-password-toggle">
              <div class="input-group-prepend">
                <span class="input-group-text"><span [data-feather]="'lock'"></span></span>
              </div>
              <input
                [ngClass]="{
                  'is-invalid error': submitted && f['password'].errors,
                }"
                [type]="passwordTextType ? 'text' : 'password'"
                aria-describedby="login-password"
                class="form-control form-control-merge"
                formControlName="password"
                id="login-password"
                placeholder="·········"
                tabindex="2" />

              <span class="input-group-text cursor-pointer"
                ><i
                  (click)="togglePasswordTextType()"
                  [ngClass]="{
                    'icon-eye-off': passwordTextType,
                    'icon-eye': !passwordTextType,
                  }"
                  class="feather font-small-4"></i
              ></span>
            </div>
            @if (submitted && f["password"].errors) {
              <div
                class="invalid-feedback"
                [ngClass]="{ 'd-block': submitted && f['password'].errors }">
                @if (f["password"].errors["required"]) {
                  <div [translate]="'AUTH.ERRORS.PASSWORD'"></div>
                }
              </div>
            }
          </div>
          <button
            [translate]="'AUTH.SIGN_IN'"
            class="btn btn-primary d-block w-100"
            rippleEffect
            tabindex="4"></button>
        </form>

        <div class="divider my-2">
          <div
            [translate]="'AUTH.OR'"
            class="divider-text"></div>
        </div>

        <div class="auth-footer-btn d-flex justify-content-center">
          <a
            [href]="website"
            class="btn btn-outline-primary"
            rippleEffect
            target="_blank">
            <i data-feather="globe"></i>
          </a>
          <a
            [href]="'mailto:' + email"
            class="btn btn-outline-primary"
            rippleEffect>
            <i data-feather="mail"></i>
          </a>
          <a
            [href]="'tel:' + phone"
            class="btn btn-outline-primary"
            rippleEffect>
            <i data-feather="phone"></i>
          </a>
        </div>
      </div>
    </div>
    <!-- /Login v1 -->
  </div>
</div>
